import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { RequisitionsFlowsHttpClient } from './flows.http-client';
import { RequisitionsFlowsActions } from './flows.store';

@Injectable({ providedIn: 'root' })
export class RequisitionsFlowsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(RequisitionsFlowsHttpClient);

  public effects = createEffectFactory(RequisitionsFlowsActions, this.actions$);

  public fetchCollection$ = this.effects(RequisitionsFlowsActions.fetchCollection, () =>
    this.http.fetchCollection().pipe(map(data => ({ data: data.approvalFlows }))),
  );

  public create$ = this.effects(
    RequisitionsFlowsActions.createOnePessimistic,
    ({ payload: { data } }) =>
      this.http.create({ approvalFlow: data }).pipe(map(data => ({ data: data.approvalFlow }))),
  );

  public update$ = this.effects(
    RequisitionsFlowsActions.updateOnePessimistic,
    ({ payload: { data } }) => {
      const { id, ...flowData } = data;
      return this.http
        .update(id!, { approvalFlow: flowData })
        .pipe(map(data => ({ data: data.approvalFlow })));
    },
  );

  public delete$ = this.effects(
    RequisitionsFlowsActions.removeOnePessimistic,
    ({ payload: { data } }) =>
      this.http.delete(data).pipe(map(data => ({ data: data.approvalFlow }))),
  );

  public setAsDefault$ = this.effects(
    RequisitionsFlowsActions.setAsDefault,
    ({ payload: { data } }) =>
      this.http.update(data.id!, { approvalFlow: { default: true } }).pipe(
        map(data =>
          RequisitionsFlowsActions.setAsDefaultSuccess({ payload: { data: data.approvalFlow } }),
        ),
        catchError(error => of(RequisitionsFlowsActions.setAsDefaultFailed({ payload: error }))),
      ),
  );

  public refresh$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RequisitionsFlowsActions.setAsDefaultSuccess),
      map(() => RequisitionsFlowsActions.fetchCollection()),
    ),
  );
}
